"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeolocationContext = exports.useCurrentLocation = exports.GeolocationProvider = void 0;
const react_1 = __importDefault(require("react"));
const useGeolocation_1 = __importDefault(require("./useGeolocation"));
const GeolocationContext = react_1.default.createContext({
    currentLocation: undefined,
    hasError: undefined,
    hasPermissionDenied: undefined,
    isLoading: undefined,
    isSuccess: undefined,
    isEnabled: false,
    setIsEnabled: () => undefined,
});
exports.GeolocationContext = GeolocationContext;
const ErrorCodes = {
    TIMEOUT: 3,
    PERMISSION_DENIED: 1,
    POSITION_UNAVAILABLE: 2,
};
const GEOLOCATION_OPTIONS = {
    maximumAge: 1,
    timeout: 5000,
    enableHighAccuracy: true,
};
function GeolocationProvider({ children }) {
    const geolocation = (0, useGeolocation_1.default)(GEOLOCATION_OPTIONS, false);
    const contextValue = react_1.default.useMemo(() => {
        var _a, _b, _c;
        const isSuccess = !(geolocation === null || geolocation === void 0 ? void 0 : geolocation.isLoading) && Boolean(geolocation === null || geolocation === void 0 ? void 0 : geolocation.latitude) && Boolean(geolocation === null || geolocation === void 0 ? void 0 : geolocation.longitude) && !(geolocation === null || geolocation === void 0 ? void 0 : geolocation.error);
        return Object.assign(Object.assign({ isLoading: Boolean(geolocation === null || geolocation === void 0 ? void 0 : geolocation.isLoading) }, (isSuccess && {
            currentLocation: {
                latitude: (_a = geolocation.latitude) === null || _a === void 0 ? void 0 : _a.valueOf(),
                longitude: (_b = geolocation.longitude) === null || _b === void 0 ? void 0 : _b.valueOf(),
            },
        })), { isSuccess, hasError: Boolean(!(geolocation === null || geolocation === void 0 ? void 0 : geolocation.isLoading) && (geolocation === null || geolocation === void 0 ? void 0 : geolocation.error)), hasPermissionDenied: ((_c = geolocation === null || geolocation === void 0 ? void 0 : geolocation.error) === null || _c === void 0 ? void 0 : _c.code) === ErrorCodes.PERMISSION_DENIED, isEnabled: geolocation.isEnabled, setIsEnabled: geolocation.setIsEnabled });
    }, [geolocation.isLoading, geolocation.error, geolocation.longitude, geolocation.latitude, geolocation.isEnabled]);
    return react_1.default.createElement(GeolocationContext.Provider, { value: contextValue }, children);
}
exports.GeolocationProvider = GeolocationProvider;
function useCurrentLocation(enabled = true) {
    const context = react_1.default.useContext(GeolocationContext);
    if (!context) {
        throw new ReferenceError('Geolocation Provider could not be found');
    }
    if (enabled && !context.isEnabled) {
        context.setIsEnabled(true);
    }
    return context;
}
exports.useCurrentLocation = useCurrentLocation;
